export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hip_hop.abd6bc9.svg";